<template>
  <autoresponders />
</template>

<script>
import Autoresponders from '@/components/Services/Hosting/Shared/Email/Autoresponders/Autoresponders'

export default {
  name: 'EmailRespondersView',
  components: { Autoresponders }
}
</script>
